import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1518c581"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "content",
  ref: "contentRef",
  id: "ASRR-content"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "file-btns" }
const _hoisted_4 = { class: "btns" }
const _hoisted_5 = { class: "inputs" }
const _hoisted_6 = { class: "price-info" }
const _hoisted_7 = { class: "price-label" }
const _hoisted_8 = { class: "price-num" }
const _hoisted_9 = { class: "tool-bar" }
const _hoisted_10 = { class: "tips-box" }
const _hoisted_11 = { class: "tips" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oio_button = _resolveComponent("oio-button")!
  const _component_ExclamationCircleOutlined = _resolveComponent("ExclamationCircleOutlined")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_oio_spin = _resolveComponent("oio-spin")!
  const _component_oio_modal = _resolveComponent("oio-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.portActionBtnShow || _ctx.portActionBtnShow.showImportBtn)
            ? (_openBlock(), _createBlock(_component_oio_button, {
                key: 0,
                type: "primary",
                onClick: _ctx.importDataEvent,
                loading: _ctx.importLoading
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导入 ")
                ]),
                _: 1
              }, 8, ["onClick", "loading"]))
            : _createCommentVNode("", true),
          (!_ctx.portActionBtnShow ||_ctx.portActionBtnShow.showExportBtn)
            ? (_openBlock(), _createBlock(_component_oio_button, {
                key: 1,
                type: "primary",
                onClick: _ctx.exportDataEvent
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出 ")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createTextVNode(" 申请退货金额： "),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.removeDecimalZero(_ctx.totalAmount)), 1),
              _createTextVNode(" 元 ")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _withDirectives(_createElementVNode("div", _hoisted_10, [
          _createVNode(_component_ExclamationCircleOutlined, { style: {"font-size":"16px","color":"var(--oio-error-color)"} }),
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.tips), 1)
        ], 512), [
          [_vShow, _ctx.tips]
        ]),
        _withDirectives(_createVNode(_component_oio_button, { onClick: _ctx.showErrorModal }, {
          default: _withCtx(() => [
            _createTextVNode(" 更多信息")
          ]),
          _: 1
        }, 8, ["onClick"]), [
          [_vShow, _ctx.errorData.length]
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_oio_spin, { loading: _ctx.tableLoading }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_table, {
            border: "",
            "header-align": "center",
            ref: "tableRef",
            height: "400",
            "keep-source": "",
            "column-config": { resizable: true },
            data: _ctx.dataSource,
            "edit-config": { trigger: 'click', mode: 'cell' },
            "scroll-y": { enabled: true, gt: 0 },
            onCheckboxChange: _ctx.checkboxChangeEvent,
            onCheckboxAll: _ctx.checkboxChangeEvent,
            onEditClosed: _cache[0] || (_cache[0] = (scope) => _ctx.$nextTick(() => _ctx.onChangeRow(scope)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_column, {
                type: "checkbox",
                fixed: "left",
                width: "50"
              }),
              _createVNode(_component_vxe_column, {
                type: "seq",
                title: "行号",
                fixed: "left",
                width: "50"
              }),
              _createVNode(_component_vxe_column, {
                field: "expLabel",
                title: "标签",
                width: "200"
              }),
              _createVNode(_component_vxe_column, {
                field: "tradeOrderCode",
                title: "订单号",
                width: "200"
              }),
              _createVNode(_component_vxe_column, {
                field: "tmsOrderCode",
                title: "发货单号",
                width: "200"
              }),
              _createVNode(_component_vxe_column, {
                field: "outCode",
                title: "ERP商品编码",
                width: "200"
              }),
              _createVNode(_component_vxe_column, {
                field: "itemName",
                title: "商品名称",
                width: "200"
              }),
              _createVNode(_component_vxe_column, {
                field: "assemblyItemDisplay",
                title: "关联子件",
                width: "200"
              }),
              _createVNode(_component_vxe_column, {
                field: "itemNumber",
                title: "货号",
                width: "100"
              }),
              _createVNode(_component_vxe_column, {
                field: "characteristics",
                title: "产品特性",
                width: "100"
              }),
              _createVNode(_component_vxe_column, {
                field: "priceType",
                title: "价格类型",
                width: "100"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.priceTypeEnumList[row.priceType]), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_column, {
                field: "externalMaterialGroup",
                title: "外部物料组",
                width: "100"
              }),
              _createVNode(_component_vxe_column, {
                field: "saleUnitName",
                title: "单位",
                width: "100"
              }),
              _createVNode(_component_vxe_column, {
                field: "saleUnitPrice",
                title: "商品进货价",
                width: "200",
                formatter: _ctx.vxeTableRemoveZeroFormatter
              }, null, 8, ["formatter"]),
              _createVNode(_component_vxe_column, {
                field: "actualUnitPrice",
                title: "成交单价",
                width: "200",
                formatter: _ctx.vxeTableRemoveZeroFormatter
              }, null, 8, ["formatter"]),
              _createVNode(_component_vxe_column, {
                field: "settlementPrice",
                title: "结算单价",
                width: "200",
                formatter: _ctx.vxeTableRemoveZeroFormatter
              }, null, 8, ["formatter"]),
              _createVNode(_component_vxe_column, {
                field: "rebatePayPrice",
                title: "权益金支付单价",
                width: "200",
                formatter: _ctx.vxeTableRemoveZeroFormatter
              }, null, 8, ["formatter"]),
              _createVNode(_component_vxe_column, {
                field: "applyRefundUnitPrice",
                title: "申请售后单价",
                width: "200",
                formatter: _ctx.vxeTableRemoveZeroFormatter
              }, null, 8, ["formatter"]),
              _createVNode(_component_vxe_column, {
                field: "reverseDiscount",
                title: "售后扣率",
                width: "200",
                formatter: _ctx.vxeTableRemoveZeroFormatter
              }, null, 8, ["formatter"]),
              _createVNode(_component_vxe_column, {
                field: "policyPromotionType",
                title: "促销类型",
                width: "200"
              }),
              _createVNode(_component_vxe_column, {
                field: "promotionSimpleCode",
                title: "促销简码",
                width: "100"
              }),
              _createVNode(_component_vxe_column, {
                field: "exWarehouseNum",
                title: "出库数量",
                width: "200"
              }),
              _createVNode(_component_vxe_column, {
                field: "residueReturnNum",
                title: "剩余可退数量",
                width: "200"
              }),
              _createVNode(_component_vxe_column, {
                field: "applyReverseNum",
                title: "申请售后数量",
                width: "200"
              }),
              _createVNode(_component_vxe_column, {
                field: "applyRefundAmount",
                title: "申请售后金额",
                width: "200",
                formatter: _ctx.vxeTableRemoveZeroFormatter
              }, null, 8, ["formatter"]),
              _createVNode(_component_vxe_column, {
                title: "售后原因",
                width: "180"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", null, _toDisplayString(scope.row?.reason?.reason ?? ''), 1)
                ]),
                _: 1
              }),
              (!_ctx.DoubleSourceFindInvisible)
                ? (_openBlock(), _createBlock(_component_vxe_column, {
                    key: 0,
                    title: "是否二次寻源",
                    width: "180"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", null, _toDisplayString(scope.row.isSecondTrace ? '是' : '否'), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["data", "onCheckboxChange", "onCheckboxAll"])
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _createVNode(_component_oio_modal, {
      visible: _ctx.errorModal,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.errorModal) = $event)),
      title: "提示信息",
      width: 600
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_table, {
          "header-align": "center",
          border: "",
          data: _ctx.errorData,
          "max-height": 400,
          ref: "errorTableRef"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_vxe_column, {
              type: "seq",
              width: "60"
            }),
            _createVNode(_component_vxe_column, {
              field: "msg",
              title: "提示信息"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 512))
}